import React from 'react';
import Text from '../animation/Text';
import { ITextProps } from '../animation/Text';
import classNames from 'classnames';

interface IRichTextProps extends ITextProps {
  data: any;
  className?: string;
  tag?: string;
  children?: React.ReactNode;
}

const RichText = ({ data, children, className, ...props }: IRichTextProps) => {
  const content = data ? { dangerouslySetInnerHTML: { __html: data } } : { children };

  return <Text className={classNames('richText', className)} {...props} {...content} />;
};

export default RichText;
